import * as React from 'react';
import classnames from 'classnames';
import { Price, Button, toast } from '@grandvisionhq/common';
import { Divider } from '@grandvisionhq/elements';
import { CheckboxWithLabel } from '@grandvisionhq/forms';
import { Icon } from '@grandvisionhq/icons';
import { Text } from '@grandvisionhq/iris-ui';

const LineItemUpsell = ({ labels , currency , sku , showImplicitTermsAndConditions =false , value , onTermsAndConditionsChange , handleOpenModal , handleAddToCart , isChecked =false , errorMessageKey  })=>{
    const [shouldShowError, setShouldShowError] = React.useState(false);
    const handleConsentChange = ({ checked  })=>{
        onTermsAndConditionsChange === null || onTermsAndConditionsChange === void 0 ? void 0 : onTermsAndConditionsChange(checked);
        setShouldShowError(!checked);
    };
    const handleClick = ()=>{
        if (!showImplicitTermsAndConditions && !isChecked) {
            setShouldShowError(true);
            errorMessageKey && toast.failed(errorMessageKey);
            return;
        }
        handleAddToCart === null || handleAddToCart === void 0 ? void 0 : handleAddToCart(sku);
    };
    return /*#__PURE__*/ React.createElement("aside", {
        className: "card-section line-item-upsell"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "line-item-upsell__header"
    }, /*#__PURE__*/ React.createElement(Text, {
        component: "h3",
        variant: "body-head"
    }, labels.title), /*#__PURE__*/ React.createElement(Text, {
        variant: "body-head",
        className: classnames('line-item-upsell__header-price', {
            'line-item-upsell__header-price--green': !value
        })
    }, value ? /*#__PURE__*/ React.createElement(React.Fragment, null, '+', " ", /*#__PURE__*/ React.createElement(Price, {
        value: value,
        currency: currency
    })) : labels.free)), /*#__PURE__*/ React.createElement("div", {
        className: "line-item-upsell__content"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "line-item-upsell__usps"
    }, /*#__PURE__*/ React.createElement("ul", {
        className: "line-item-upsell__usps-list"
    }, labels.uspList.map((usp, index)=>/*#__PURE__*/ React.createElement("li", {
            key: index
        }, /*#__PURE__*/ React.createElement(Icon, {
            name: "checkmark-circle",
            height: 16,
            width: 16
        }), /*#__PURE__*/ React.createElement(Text, {
            variant: "body-head",
            component: "span"
        }, usp))
    )), Boolean(handleOpenModal) && /*#__PURE__*/ React.createElement(Button, {
        variant: "ghost",
        onClick: handleOpenModal,
        size: "small",
        caption: labels.moreAbout
    }), !showImplicitTermsAndConditions && /*#__PURE__*/ React.createElement(Divider, {
        theme: "light"
    })), Boolean(handleAddToCart) && /*#__PURE__*/ React.createElement(Button, {
        className: "line-item-upsell__cta",
        caption: labels.add,
        "aria-label": labels.add,
        variant: "outline",
        size: "small",
        onClick: handleClick
    }), /*#__PURE__*/ React.createElement("div", {
        className: "termsAndConditions"
    }, showImplicitTermsAndConditions ? /*#__PURE__*/ React.createElement(Text, {
        variant: "body"
    }, labels.implicitTermsAndAgreementLabel) : /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Text, {
        variant: "body"
    }, labels.explicitTermsAndAgreementLabel), /*#__PURE__*/ React.createElement(CheckboxWithLabel, {
        "data-t": "consent",
        label: labels.consent,
        onChange: handleConsentChange,
        value: "consent",
        checked: isChecked,
        errorMessage: labels.errorMessage,
        error: shouldShowError
    })))));
};

export { LineItemUpsell };
//# sourceMappingURL=LineItemUpsell.js.map
